import { Component, Input, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CardStudentContact } from '../card-student-contact';
import { TylerMatTableDataSource } from '../../../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../../../shared-components/angular-material/mat-animations';
import { SendEmailService } from '../../../../../../shared-modules/send-email/send-email.service';
import { Router } from '@angular/router';

@Component({
    selector: 'tyl-contacts-v9',
    templateUrl: './contacts-v9.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./contacts-v9.component.css'],
    animations: [detailExpand]
})
export class ContactsV9Component implements OnInit {
    @Input() contacts: CardStudentContact[];

    displayedColumns: string[] = ['contactKey', 'name', 'relationship', 'home', 'cell', 'more'];
    angularMatData = new TylerMatTableDataSource();
    parentType = ['Household', 'Emergency', 'Nonresident'];
    studentContacts = new Array<CardStudentContact>();

    constructor(private cdr: ChangeDetectorRef, private sendEmailService: SendEmailService, private router: Router) {
    }

    ngOnInit() {
        if (this.contacts) {
            this.contacts.forEach(contact => {
                contact.IsHeader = false;
            });

            const houseHoldParent = new CardStudentContact();
            houseHoldParent.Contact_Name = 'Household Parents/Guardians';
            houseHoldParent.IsHeader = true;
            houseHoldParent.HomeNumber = '';
            houseHoldParent.CellNumber = '';
            this.studentContacts.push(houseHoldParent);
            this.contacts.filter(o => o.ParentType == 'Household').forEach(element => {
                this.studentContacts.push(element);
            });

            if (this.contacts.filter(o => o.ParentType == 'Emergency').length > 0) {
                const emergencyContact = new CardStudentContact();
                emergencyContact.Contact_Name = 'Emergency Contacts';
                emergencyContact.IsHeader = true;
                emergencyContact.HomeNumber = '';
                emergencyContact.CellNumber = '';
                this.studentContacts.push(emergencyContact);
                this.contacts.filter(o => o.ParentType == 'Emergency').forEach(element => {
                    this.studentContacts.push(element);
                });
            }

            if (this.contacts.filter(o => o.ParentType == 'Nonresident').length > 0) {
                const nonResidentParent = new CardStudentContact();
                nonResidentParent.Contact_Name = 'Nonresident Parents';
                nonResidentParent.IsHeader = true;
                nonResidentParent.HomeNumber = '';
                nonResidentParent.CellNumber = '';
                this.studentContacts.push(nonResidentParent);
                this.contacts.filter(o => o.ParentType == 'Nonresident').forEach(element => {
                    this.studentContacts.push(element);
                });
            }

            this.angularMatData = new TylerMatTableDataSource(this.studentContacts);
            this.angularMatData.data = this.studentContacts;
        }
    }

    updateView() {
        this.cdr.detectChanges();
    }

    sendEmail(name: string, emailAddress: string) {
        this.sendEmailService.teacherEmailAddress = emailAddress;
        this.sendEmailService.teacherName = name;
        this.router.navigateByUrl('/student360/sendEmail');
    }


    toggleExpanded(row: any) {
        // Toggles row between expanded and collapsed
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        // Return true if expanded and false if collapsed
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        //  Expand or collapse all rows
        //  true => expand all    false => collapse all
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    getParentContactTableData(parentType: string): CardStudentContact[] {
        return this.contacts.filter(contact => contact.ParentType == parentType);
    }

}
